import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createMarketingSenderDomain,
  deleteMarketingSenderDomain,
  getMarketingSenderDomains,
  updateMarketingSenderDomain,
  verifyMarketingSenderDomain,
} from "api/bMarketingApi";

export function useMarketingSenderDomains(organisationId) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["marketingSenderDomains", organisationId],
    queryFn: () => getMarketingSenderDomains(organisationId).then((res) => res.data),
    enabled: !!organisationId,
  });

  return {
    senderDomains: data || [],
    isLoading,
    error,
    refetch,
  };
}

export function useCreateMarketingSenderDomain() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createMarketingSenderDomain(data).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["marketingSenderDomains"] });
    },
  });
}

export function useUpdateMarketingSenderDomain() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ senderDomainId, data }) => updateMarketingSenderDomain(senderDomainId, data).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["marketingSenderDomains"] });
    },
  });
}

export function useVerifyMarketingSenderDomain() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (senderDomainId) => verifyMarketingSenderDomain(senderDomainId).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["marketingSenderDomains"] });
    },
  });
}

export function useDeleteMarketingSenderDomain() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (senderDomainId) => deleteMarketingSenderDomain(senderDomainId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["marketingSenderDomains"] });
    },
  });
}